import styled, { css } from 'styled-components';

export const ClinicSection = styled.section`
  padding: 0 16px;
`;

export const ClinicHealthContainer = styled.div`
  border: ${(props) =>
    props.topicListing ? 'none' : ' 1px solid hsl(0deg, 0%, 0%, 60%)'};
  padding: ${(props) =>
    props.topicListing ? '20px 20px 16px' : '30px 30px 16px'};
  border-radius: 10px;

  @media (max-width: 720px) {
    padding: 20px 20px 4px;
  }

  .custom_radio:checked,
  .custom_radio:not(:checked) {
    position: absolute;
    left: -9999px;
  }

  .custom_radio:checked + .custom_label,
  .custom_radio:not(:checked) + .custom_label {
    position: relative;
    padding-left: 28px;
    line-height: 20px;
    display: inline-block;
    color: hsl(0deg 0% 0% / 80%);
    font-weight: 500;
    font-size: ${(props) =>
      props.topicListing ? '14px' : 'clamp(15px, 2vw, 16px)'};
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  .custom_radio:checked + .custom_label:before,
  .custom_radio:not(:checked) + .custom_label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: ${(props) => (props.topicListing ? '16px' : '18px')};
    height: ${(props) => (props.topicListing ? '16px' : '18px')};
    border: ${(props) =>
      props.topicListing
        ? '1px solid #00000033'
        : '1px solid hsl(0deg 0% 0% / 80%)'};
    border-radius: 50%;
    background: #fff;
  }

  .custom_radio:checked + .custom_label:after,
  .custom_radio:not(:checked) + .custom_label:after {
    content: '';
    width: ${(props) => (props.topicListing ? '8px' : '10px')};
    height: ${(props) => (props.topicListing ? '8px' : '10px')};
    background: ${(props) =>
      props.topicListing ? '#ef4e5e' : 'hsl(0deg 0% 0% / 80%)'};
    position: absolute;
    top: 4px;
    left: 4px;
    border-radius: 50%;
    transition: all 0.2s ease;
  }

  .custom_radio:not(:checked) + .custom_label:after {
    opacity: 0;
    transform: scale(0);
  }

  .custom_radio:checked + .custom_label:after {
    opacity: 1;
    transform: scale(1);
  }

  .custom_radio:checked + .custom_label:before {
    border: ${(props) =>
      props.topicListing
        ? '1px solid #ef4e5e'
        : '1px solid hsl(0deg 0% 0% / 80%)'};
  }

  .custom_radio:checked + .custom_label {
    color: #ef4e5e;
  }
`;

export const RadioFormGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  margin-bottom: 16px;
  border-bottom: 1px solid hsl(0deg, 0%, 0%, 20%);

  &.noBorder {
    border-bottom: none;
  }
`;

export const PlanPrice = styled.span`
  font-weight: 600;
  color: hsl(0deg 0% 0% / 87%);
  font-size: 16px;
`;

export const PlanStrikePrice = styled.span`
  color: hsl(0deg 0% 0% / 40%);
  font-size: 16px;
  text-decoration: line-through;
  font-weight: 500;
  padding-right: 16px;
`;

export const BookNowCtabtn = styled.button`
  font-family: 'Montserrat';
  font-size: clamp(16px, 2vw, 14px);
  font-weight: 500;
  outline: none;
  background-color: #ef4e5e;
  color: #fff;
  border-radius: 6px;
  text-align: center;
  width: 100%;
  height: 44px;
  line-height: 44px;
  margin: 20px 0;
  border: 1px solid #ef4e5e;
  cursor: pointer;
  z-index: 999;
  background: ${(props) => (props.formSubmitted ? '#d9d9d9' : null)};
  cursor: ${(props) => (props.formSubmitted ? 'not-allowed' : null)};
  border: ${(props) => (props.formSubmitted ? 'none' : null)};
  transition: all 0.3s ease;
  @media (max-width: 720px) {
    cursor: default;
    position: fixed;
    bottom: 0;
    margin: 0;
    left: 0;
    right: 0;
    border-radius: 0;
    z-index: 999;
  }

  .disable {
    background: #d9d9d9;
    cursor: not-allowed;
  }

  // &:hover {
  //     background: #ef4e5ec9;
  // }
`;

export const HealthDetailPopupContainer = styled.div`
  padding: 30px 40px;
  min-height: max-content;
  overflow-y: auto;

  @media (max-width: 720px) {
    padding: 30px 12px;
  }

  &::-webkit-scrollbar {
    width: 0;
    transition: all 0.3s ease;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  &:hover {
    &::-webkit-scrollbar {
      width: 3px;
    }
  }
`;

export const GeneralFormContainer = styled.div`
  padding: 14px;
  min-height: max-content;
  margin: auto;

  @media (max-width: 720px) {
    padding: 16px;
    max-width: 100%;
  }
`;

export const FormBox = styled.div`
  text-align: center;
  line-height: 21px;
  padding: 10px 10px 10px;
  width: 100%;
  margin: auto;

  @media (max-width: 720px) {
    padding: 10px 10px 10px;
    max-width: 100%;
  }
`;

export const BookingSuccessfulTitle = styled.h5`
  font-size: 16px;
  color: #63b0a8;
  font-weight: 600;
  letter-spacing: 0.3px;
  padding: 8px 0px;
  border-bottom: 1px solid #4d8b7e33;
  margin: 0 54px 10px;
`;

export const ContactUs = styled.button`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #ef4e5e;
  background-color: #fff;
  font-family: 'Montserrat';
  height: 42px;
  line-height: 42px;
  outline: none;
  width: 100%;
  margin: 12px 0;
  color: #ef4e5e;
  border-radius: 4px;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 600;

  &:hover {
    background-color: #ef4e5e;
    color: #fff;
  }

  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const BookingSuccessfulDesc = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: rgb(0 0 0 / 80%);
`;

export const ChangeNumber = styled.div`
  display: flex;
  justify-content: space-between;
  background: #e7f9f0;
  padding: 8px 16px;
  align-items: flex-end;
  font-size: 13px;
  border-radius: 4px;
  text-align: left;
  margin: 20px 0;
`;

export const NeedAssistance = styled.div`
  background: rgb(243 249 248 / 60%);
  padding: 16px;
  border-top: 1px solid rgb(0 0 0 / 10%);

  p {
    font-size: 14px;
    font-weight: 500;
    color: hsl(0deg, 0%, 0%, 80%);
  }
`;

export const ChangeBtn = styled.button`
  background: none;
  border: none;
  outline: none;
  color: hsl(0deg, 0%, 0%, 50%);
  text-decoration: underline;
  font-size: 12px;
  font-family: 'Montserrat';
`;

export const PopupInput = styled.input`
  width: 90%;
  // margin: 16px auto;
  background: #fff;
  border: solid 1px #dbdbdb;
  border-radius: 6px;
  height: 46px;
  outline: none;
  padding: 0 16px;
  font-family: 'Montserrat';
  text-transform: capitalize;
  display: block;
`;

export const SelectInput = styled.select`
  width: 90%;
  margin: 16px 0;
  background: #fff;
  height: 46px;
  outline: none;
  padding: 0 16px;
  font-family: 'Montserrat';
  display: block;
  margin: auto;
  text-transform: capitalize;
`;

export const EnterDetails = styled.h2`
  color: hsl(0deg, 0%, 0%, 87%);
  padding-bottom: 10px;
  text-align: center;
  font-size: 20px;
`;

export const ReciveInfo = styled.p`
  font-size: 12px;
  color: hsl(0deg, 0%, 0%, 60%);
  font-weight: 500;
  text-align: left;
  padding: 16px 0 30px;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 36px;
    height: 36px;
    margin-bottom: 8px;
  }
`;

export const PlanSelectedSection = styled.div`
  margin: 0 0 10px;
`;

export const PlanSelectedTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 40%);
  text-transform: uppercase;
`;

export const SelectedPlanName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
`;

export const RadioInputSection = styled.div`
  display: flex;
  align-items: center;

  ${(props) =>
    props.showNewUI
      ? css`
          flex-direction: column;
          row-gap: 20px;
          align-items: flex-start;
          margin: auto;
        `
      : ''}
  h2 {
    font-size: clamp(20px, 2vw, 22px);
    width: 90%;
    margin: 10px auto 0;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 600;
  }

  p {
    font-size: 15px;
    width: 90%;
    margin: auto;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 500;
  }
`;

export const RadioOption = styled.div`
  display: flex;
  align-items: center;
  flex-basis: 20%;
  @media (max-width: 720px) {
    flex-basis: 28%;
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 600ms linear;
    background-color: hsl(0deg, 0%, 0%, 18%);
    z-index: 10;
  }

  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  position: relative;
  overflow: hidden;

  input {
    width: 16px;
    height: 16px;
    margin-right: 8px;

    &:checked {
      accent-color: #4f4f4f;
    }

    z-index: 100;
    ${(props) =>
      props.showNewUI
        ? css`
            width: 25px;
            height: 20px;
            margin-right: 25px;
          `
        : ''}
  }

  -webkit-tap-highlight-color: transparent;
  ${(props) =>
    props.showNewUI
      ? css`
          width: 90%;
          margin: auto;
          column-gap: 6px;
          padding-left: 10px;
          border-radius: ${props.checkBoxRadio ? '6px' : '4px'};
          background: #f2f2f2;
          border: ${props.activeIndex ? '1px solid #000' : ''};
          flex-direction: row-reverse;
          box-shadow: ${props.activeIndex
            ? '0 3px 6px 0 rgba(0, 0, 0, 0.16)'
            : ''};
        `
      : ''}
`;

export const DropDownLabel = styled.label`
  font-size: 14px;
  flex-basis: 60%;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  text-align: left;

  @media (max-width: 720px) {
    flex-basis: 80%;
  }
`;

export const CheckboxLabel = styled.label`
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 20px 0;
  z-index: 100;
`;

export const QuestionLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: rgb(0 0 0 / 87%);
  padding: 20px 0 0;
  display: inline-block;
  ${(props) =>
    props.showNewUI
      ? css`
          font-size: 16px;
          font-weight: 600;
          width: 90%;
          margin: auto;
          display: block;
        `
      : ''}
`;

export const RadioLabel = styled.label`
  font-size: ${(props) => (props.showNewUI ? '16px' : '14px')};
  font-weight: ${(props) => (props.showNewUI ? '500' : '600')};
  color: hsl(0deg, 0%, 0%, 80%);
  width: 100%;
  -webkit-tap-highlight-color: transparent;
  @media (min-width: 768px) {
    cursor: pointer;
  }
  padding: 20px 0;
`;
export const ErrorTextStyle = styled.p`
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  color: #ef4e5e;
  padding-top: 6px;
  width: 90%;
  margin: auto;
`;
export const Toast = styled.div`
  background: #000;
  opacity: 0.8;
  padding: 0 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  position: fixed;
  z-index: 9999;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  bottom: 80px;
  max-width: 330px;
  margin: 0 auto;
  left: 0;
  right: 0;
  border-radius: 4px;

  & p {
    font-weight: 400;
  }
`;

export const WhereShouldReach = styled.section`
  margin: 8px 0;
`;

export const CheckBoxTitle = styled.h4`
  text-align: left;
  font-size: clamp(14px, 2vw, 16px);
  padding: 10px 0;
  color: #000000e0;
`;
